export default __webpack_public_path__ + "static/media/alphabank.6c89012a.ico";